import { Component, OnInit, inject, signal } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { LoggerService } from '@app/shared/services/logger.service';
import { Observable, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from '@app/app.service';
import { Tag } from '@app/shared/models/assets.model';
import { Game } from '@app/shared/models/game.model';
import { GamesRepository } from '@app/shared/state/games/games.repository';
import { TagsRepository } from '@app/shared/state/tags/tags.repository';
import { SharedModule } from '@app/shared/shared.module';
import { SearchInputComponent } from '@app/shared/components/search-input/search-input.component';
import { LobbyGameComponent } from '@app/home/lobby/lobby-game/lobby-game.component';

@TakeUntilDestroy
@Component({
  selector: 'search-game-modal',
  templateUrl: './search-game-modal.component.html',
  styleUrls: ['./search-game-modal.component.scss'],
  standalone: true,
  imports: [SharedModule, SearchInputComponent, LobbyGameComponent],
})
export class SearchGameModalComponent implements OnInit {
  gamesFiltered: Game[] = [];
  isLoaded = signal(false);
  gameImagesPaths: string[] = [];
  gameUnlockFlip = signal(false);
  notFound = signal(false);

  componentDestroy: () => Observable<unknown>;

  get tagsList(): Tag[] {
    return this.tagsRepo.getAllTags();
  }

  get games(): Game[] {
    return this.gamesRepo.getAllGames();
  }

  public readonly dialog = inject(MatDialog);
  private readonly eventManager = inject(EventManager);
  public readonly logger = inject(LoggerService);
  private readonly gamesRepo = inject(GamesRepository);
  public readonly appService = inject(AppService);
  private readonly tagsRepo = inject(TagsRepository);
  public readonly searchGameModalData = inject<Modal>(MAT_DIALOG_DATA);

  ngOnInit(): void {
    this.startAnimation();
    this.isLoaded.set(true);
  }

  applyFilter(value: string) {
    if (value.length > 1) {
      this.gamesFiltered = this.games.filter(
        (game) => game.gameTitle.toLocaleLowerCase().includes(value.toLocaleLowerCase()) && !game.isHidden
      );

      if (this.gamesFiltered.length > 0) {
        this.notFound.set(false);
        this.gamesFiltered = this.gamesFiltered.slice(0, 10);
      } else {
        this.notFound.set(true);
      }
    } else {
      this.gamesFiltered = [];
    }
  }

  startAnimation() {
    timer(5000, 5000)
      .pipe(takeUntil(this.componentDestroy()))
      .subscribe({
        next: () => {
          this.gameUnlockFlip.set(!this.gameUnlockFlip());
        },
        error: (error) => this.logger.error(error),
      });
  }

  goBack() {
    this.eventManager.closeModal(
      new Modal(NonPersistedModalName.SearchGameModalComponent, ModalType.View, { message: 'close-modal' })
    );
  }
}
